/** Empty queue — Mission Control PanelEmptyState chrome. */

import { faSparkles } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import { PanelEmptyState } from "@/components/mission-control/PanelEmptyState";

interface ReviewQueueEmptyProps {
  allReviewed?: boolean;
}

export function ReviewQueueEmpty({ allReviewed = false }: ReviewQueueEmptyProps) {
  return (
    <PanelEmptyState
      icon={faSparkles}
      title={allReviewed ? "All cases reviewed" : "No cases yet"}
      subtitle={
        allReviewed
          ? "You've worked through the whole queue. Clear the queue or import more cases."
          : "Import tasks to add cases, or ask an engineer to seed the review queue."
      }
    />
  );
}
